module.exports = __webpack_public_path__ + "static/media/photonlogo_wide.0b97bb50.svg";